import ActionResult from 'app/src/engine/action-results/ActionResult';
import Star from 'app/src/engine/Star';

export default class CollectStarActionResult extends ActionResult {
	private _star: Star;
	get star(): Star {
		return this._star;
	}

	constructor(star: Star) {
		super();

		this._star = star;
	}
}
